module.exports = __webpack_public_path__ + "static/media/303ColumnLabel--8.371ae08a.svg";